module.exports = __webpack_public_path__ + "img/pic_feed_megasale.6efbc186.png";